import { useState } from "react";
import { Box, Text } from "theme-ui";

import { Button, Input } from "components";
import ModalCenter from "../ModalCenter";
import * as styles from "./ModalSave.styles";

export default function ModalSave({
  isTopMostModal,
  title,
  onClose,
  saveYourCustomDesignObj,
}) {
  const [value, setValue] = useState("");

  const handleSubmit = (evt) => {
    evt.preventDefault();
  };

  return (
    <ModalCenter isTopMostModal={isTopMostModal} onClose={onClose}>
      <Box sx={styles.contentContainer}>
        <Text variant="h4Light" sx={styles.modalTitle}>
          {title}
        </Text>
        <Text as="div" variant="copy3Light" sx={styles.descriptionText}>
          {saveYourCustomDesignObj.text}
        </Text>

        <Text as="div" variant="copy2Medium" sx={styles.subText}>
          {saveYourCustomDesignObj.subTitle}
        </Text>

        <Box as="form" onSubmit={handleSubmit} sx={styles.emailInputContainer}>
          <Input
            placeholder="recipient@domain.com"
            onChange={setValue}
            value={value}
          />
          <Button type="submit" variant="primary" size="medium" theme="dark">
            Send
          </Button>
        </Box>
      </Box>
    </ModalCenter>
  );
}
